import React, { useContext, useEffect } from "react";
import { FileLocationProviderContext } from "./FileLocationProvider";
import { FlatPathTreeExplorer, FlatPathTreeItem } from "../generic/FlatPathTreeExplorer";
import { openDocumentById } from "../../utils/helpers/OpenDocumentHelper";
import { DocumentPartWithStatus } from "../../api/models/document-part-with-status";

export interface DocumentLocationExplorerProps {
  onSelectItem: (item: FlatPathTreeItem) => void;
  defaultLocation?: FlatPathTreeItem;
  page?: string;
  searchQuery?: string;

  showDownloadButton?: boolean;
  documentPartWithStatus: DocumentPartWithStatus[] | null;
  setDocumentPartWithStatus: (statuses: DocumentPartWithStatus[] | null) => void;
  suppressOpenOnActivate?: boolean;
}

interface DocumentListWrapperState {
  loaded: boolean;
  selectedTreeItem: FlatPathTreeItem | undefined;
}

const documentListWrapperInitialState: DocumentListWrapperState = {
  loaded: true,
  selectedTreeItem: undefined,
};

export const DocumentLocationExplorer: React.FunctionComponent<DocumentLocationExplorerProps> = (props) => {
  const [state, setState] = React.useState<DocumentListWrapperState>(documentListWrapperInitialState);
  const fileLocationProvider = useContext(FileLocationProviderContext);

  useEffect(() => {
    if (props.defaultLocation) {
      fileLocationProvider.selectItemLocation(props.defaultLocation);
    }
  }, []);

  const selectItem = (item: FlatPathTreeItem) => {
    fileLocationProvider.selectItemLocation(item);
    props.onSelectItem(item);
    if (!item?.document || item.document.folder) setState({ ...state, selectedTreeItem: undefined });
    else setState({ ...state, selectedTreeItem: item });
  };

  const onItemClicked = (item: FlatPathTreeItem) => {
    if (item?.document && !item.document.folder) {
      selectItem(item);
      if (item.document.id) {
        if (!props.suppressOpenOnActivate) {
          openDocumentById(item.document.id);
        }
      } else {
        // eslint-disable-next-line no-undef
        console.warn(`Could not find document with id null`);
      }
    } else {
      fileLocationProvider.exploreLocation(item);
      props.onSelectItem(item);
    }
  };

  return (
    <FlatPathTreeExplorer
      item={fileLocationProvider.exploredLocation}
      onItemClicked={onItemClicked}
      onItemSelection={selectItem}
      page={props.page}
      selectedItem={state.selectedTreeItem}
      searchQuery={props.searchQuery}
      showDownloadButton={props.showDownloadButton}
      documentPartWithStatus={props.documentPartWithStatus}
      setDocumentPartWithStatus={props.setDocumentPartWithStatus}
    />
  );
};
